/**
 * Tyre Management V2 is a dark-launched feature. Treat every value other than
 * the explicit boolean true as disabled so a missing, loading, or failed
 * settings response cannot switch existing users onto the new workflow.
 */
export const isTyreManagementV2Enabled = (appSettings) => (
  appSettings?.tyre_management_v2_enabled === true
);

export const getVehicleWorkflow = (appSettings) => (
  isTyreManagementV2Enabled(appSettings) ? 'v2' : 'legacy'
);
